import { render } from "./NcrmPbxSyncPanel.vue?vue&type=template&id=11140d3b&scoped=true"
import script from "./NcrmPbxSyncPanel.vue?vue&type=script&lang=js"
export * from "./NcrmPbxSyncPanel.vue?vue&type=script&lang=js"

import "./NcrmPbxSyncPanel.vue?vue&type=style&index=0&id=11140d3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11140d3b"]])

export default __exports__